import React, { Component } from 'react';

class DaniContent extends Component {
  constructor(props) {
    super(props);
    this.state = {  }
  }
  render() { 
    return ( 
      <div className="dani-content" >
        {this.props.children}
      </div>
    );
  }
}
 
export default DaniContent;